import Icon, { IconButton } from '@xo-union/tk-component-icons';
import { H4 } from '@xo-union/tk-ui-typography';
import { IconName } from '@xo-union/dist-iconography';
import React, { ReactNode } from 'react';

import styles from './header.scss';
import { isKeyEnterSpace } from './helpers';

interface Props {
  onClose?: Function;
  leftIconName?: IconName;
  leftButtonText?: string;
  leftButtonOnClick?: () => void;
  children?: any;
  as?: string; // What to render the H4 component holding the "children" as, if you want it to be something other than "h4".
  closeButtonAriaLabel?: string;
  subNav?: ReactNode;
}

const LeftButton: React.FC<{ leftButtonText: string; leftButtonOnClick?: () => void }> = ({
  leftButtonText,
  leftButtonOnClick,
}) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (isKeyEnterSpace(e) && typeof leftButtonOnClick === 'function') {
      e.preventDefault(); // So the page behind doesn't scroll if you hit the spacebar to go back.
      leftButtonOnClick();
    }
  };

  return (
    <div role="button" tabIndex={0} className={styles.back} onKeyDown={e => onKeyDown(e)} onClick={leftButtonOnClick}>
      <Icon name="back" size="md" />
      <span className={styles.buttonText}>{leftButtonText}</span>
    </div>
  );
};

const CloseButton = ({ onClose, closeButtonAriaLabel }: { onClose: Function; closeButtonAriaLabel: string }) => (
  <IconButton
    className={styles.close}
    data-testid="close-icon"
    name="close"
    size="md"
    // @ts-ignore type issues with IconButton
    onClick={onClose}
    aria-label={closeButtonAriaLabel}
  />
);

export const Header: React.FC<Props> = ({
  children,
  onClose,
  leftIconName = 'back',
  leftButtonText,
  leftButtonOnClick,
  as = '',
  closeButtonAriaLabel = 'Close',
  subNav,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.mainContainer}>
        <div className={styles.containerLeft}>
          {leftButtonText && <LeftButton leftButtonText={leftButtonText} leftButtonOnClick={leftButtonOnClick} />}
          {children && <H4 as={as}>{children}</H4>}
        </div>
        {onClose && <CloseButton onClose={onClose} closeButtonAriaLabel={closeButtonAriaLabel} />}
      </div>
      {subNav}
    </div>
  );
};
